import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const removeUsers = (userIds) => {
  const body = JSON.stringify({ ids: userIds })

  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/users', fetchOptions)
}

export default removeUsers;
